import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Text } from "components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "../CompayUSerList/pagination.css";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { RiCloseLine, RiDeleteBin6Line } from "react-icons/ri";
import { FaFilePdf } from "react-icons/fa";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Swal from "sweetalert2";
import Select from "react-select";
import { pageSize } from "../../components/PaginationPageSize";
import actionbuttonCustomStyle, {
  CustomOption,
} from "styles/actionbuttonCustomStyle.";
import Pagination from "pages/Pagination/Pagination";
import StatusCapsule from "components/SmallComponents/StatusCapsule";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function TaxInvoiceCancelList() {
  const [taxinvoice, setTaxInvoice] = useState([]);
  const gridRef = useRef();
  const [count, setCount] = useState();
  const [loading, setLoading] = useState(true); // State for loading indicator
  const navigate = useNavigate();

  // for Access
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 52 && item.update
  );

  //for pagination fuctionallity ...

  const [recordPerPage, setRecordPerPage] = useState(pageSize);

  //for search fuctionallity
  const [selectedOption, setSelectedOption] = useState("column");
  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);
  const [offsetforSR, setOffsetforSR] = useState();

  const [searchCompanySpecificCriteriaId, setsearchCompanySpecificCriteriaId] =
    useState();
  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();

  //for cloumn
  const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
    useState([]);
  useEffect(() => {
    getsearchCompanySpecificCriteria();
    getsetsearchcompanyspecificdaterange();
  }, []);

  const getsearchCompanySpecificCriteria = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 1 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //for date
  const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
    useState([]);
  const getsetsearchcompanyspecificdaterange = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificdaterange/get",
        {},
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchcompanyspecificdaterange(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
  };

  // for getting the list of tax invoice...

  // useEffect(() => {
  //   getTaxInvoice();
  // }, [
  //   page,
  //   recordPerPage,
  //   searchCompanySpecificCriteriaId,
  //   searchCompanySpecificDateRangeId,
  //   searchParameter,
  // ]);
  useEffect(() => {
    if (searchCompanySpecificDateRangeId != 7 && page) {
      getTaxInvoice();
    }
  }, [
    page,
    recordPerPage,
    searchCompanySpecificCriteriaId,
    searchCompanySpecificDateRangeId,
    searchParameter,
  ]);

  useEffect(() => {
    if (
      formDate != "" &&
      toDate != "" &&
      searchParameter2 != "" &&
      searchCompanySpecificDateRangeId == 7 &&
      page
    ) {
      obj.search_parameter = searchParameter2;
      getTaxInvoice();
    }
  }, [
    page,
    // recordPerPage,
    searchParameter2,
  ]);

  //by deafult value select
  useEffect(() => {
    if (searchCompanySpecificCriteria.length > 0) {
      // Set the default selected criteria ID when the criteria list is available
      setsearchCompanySpecificCriteriaId(searchCompanySpecificCriteria[0].id);
    }
  }, [searchCompanySpecificCriteria]);

  const obj = {
    search_company_specific_criteria_id:
      searchCompanySpecificCriteriaId != undefined
        ? searchCompanySpecificCriteriaId
        : "",
    search_company_specific_date_range_id:
      searchCompanySpecificDateRangeId != undefined
        ? searchCompanySpecificDateRangeId
        : "",
    search_parameter: searchParameter,
  };

  const getTaxInvoice = () => {
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    var limit = recordPerPage;

    const requestPayload = {
      ...obj, // Include other properties from obj
      offset,
      limit,
    };
    console.log(requestPayload);
    axios
      .post("/api/purple-fusion/taxinvoice/getforpagging", requestPayload, {
        ...headers,
        timeout: 20000,
      })
      .then((response) => {
        console.log(response.data);
        const filteredData = response.data.filter(
          (item) => item.taxinvoicestatus === "Submitted"
        );
        setTaxInvoice(filteredData);
        setCount(response.data[0].count);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching tax invoivce  data:", error);
      });
  };

  const deleteTaxInvoice = (values) => {
    Swal.fire({
      title: "Are you sure?",
      html: `You want to delete tax invoice number<br><span style="color: #FF5733;">${values.code}</span><br><br>
             <input type="text" id="invoiceCodeInput" class="swal2-input" placeholder="Enter invoice code">`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      preConfirm: () => {
        const enteredCode = document.getElementById("invoiceCodeInput").value;
        if (!enteredCode) {
          Swal.showValidationMessage(`Please enter the invoice code`);
          return false; // Prevent the modal from closing
        } else if (enteredCode !== values.code) {
          Swal.showValidationMessage(`Invoice code does not match!`);
          return false; // Prevent the modal from closing
        }
        return { enteredCode: enteredCode };
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          const enteredCode = result.value.enteredCode;
          console.log(values);

          axios
            .put(
              "/api/purple-fusion/einvoice/deletetaxinvoice",
              {
                id: values.id,
                code: values.code,
                invoice_date: values.invoice_date,
                is_delivery_challan: values.is_delivery_challan,
              },
              headers
            )
            .then((response) => {
              console.log(response.data);
              const message = response.data.message;
              if (response.data.status) {
                toast.success(message, {
                  autoClose: 1000,
                });
                getTaxInvoice();
              } else if (message === "Login details are not available") {
                Swal.fire({
                  title: "Login details are not available",
                  text: "Do you still want to delete this invoice?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, delete it!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    callDeleteAPI(values);
                  }
                });
              } else {
                toast.error(message, {
                  autoClose: 1000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const callDeleteAPI = (values) => {
    console.log(values);
    axios
      .put(
        `/api/purple-fusion/taxinvoice/deletetaxinvoice/invoice`,
        { id: values.id, is_delivery_challan: values.is_delivery_challan },
        headers
      )
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        if (response.data.status) {
          toast.success(message, {
            autoClose: 1000,
          });
          getTaxInvoice();
        } else {
          toast.error(message, {
            autoClose: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetPreview = async (params, name) => {
    console.log(name);
    try {
      const requestData = {
        id: params,
      };
      console.log(requestData);

      const response = await axios.post(
        "/api/purple-fusion/taxinvoice/preview",
        requestData,
        {
          ...headers,
          responseType: "arraybuffer",
        }
      );
      // const contentDisposition = response.headers["content-disposition"];
      const FileName = response.headers["content-disposition"];

      // const contentType = response.headers["content-type"];
      const contentType = "application/pdf";
      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: contentType });

      // Check if the Blob type is supported before creating an Object URL
      if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
        const arrayBuffer = await blob.arrayBuffer();
        const url = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: contentType })
        );

        // Open a new tab and set its location to the Object URL
        window.open(url);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } else {
        console.error(
          "Blob.arrayBuffer is not supported. Unable to create Object URL."
        );
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.warning("Unable to download file. Please try again later.");
    }
  };

  //

  const handleNavigation = (option) => {
    console.log("Navigate to:", option.value);
    // console.log(params);
    if (option.value === "Preview") {
      GetPreview(option.params.data.id, option.params.data.code);
    } else if (option.value === "Delete") {
      console.log("Delete");
      deleteTaxInvoice(option.params.data);
    } else if (option.value === "Cancel") {
      Swal.fire({
        title: "Are you sure?",
        html: `You want to cancel this Invoice  <br><span style="color: #FF5733;">${option.params.data.code}</span><br><br>
               <input type="text" id="invoiceCodeInput" class="swal2-input" placeholder="Enter invoice code">`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        preConfirm: () => {
          const enteredCode = document.getElementById("invoiceCodeInput").value;
          if (!enteredCode) {
            Swal.showValidationMessage(`Please enter the invoice code`);
            return false; // Prevent the modal from closing
          } else if (enteredCode !== option.params.data.code) {
            Swal.showValidationMessage(`Invoice code does not match!`);
            return false; // Prevent the modal from closing
          }
          return { enteredCode: enteredCode };
        },
      })
        .then((result) => {
          if (result.isConfirmed) {
            option.params.data.services === "HSN" ||
            option.params.data.services === "MIX_HSN_SAC"
              ? option.params.data.is_delivery_challan
                ? navigate(
                    `/taxinvoice/cancel/services/${option.params.data.id}`,
                    {
                      state: {
                        invoice_code: option.params.data.code,
                        invoice_date: option.params.data.invoice_date,
                        customer_name: option.params.data.customername,
                        is_delivery_challan:
                          option.params.data.is_delivery_challan,
                      },
                    }
                  )
                : navigate(`/taxinvoice/cancel/${option.params.data.id}`, {
                    state: {
                      invoice_code: option.params.data.code,
                      invoice_date: option.params.data.invoice_date,
                      customer_name: option.params.data.customername,
                    },
                  })
              : navigate(
                  `/taxinvoice/cancel/services/${option.params.data.id}`
                );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const updatedActionButtonCustomStyle = {
    ...actionbuttonCustomStyle,
    menu: (base) => ({
      ...base,
      marginTop: "0px", // Change the marginTop as needed
      marginRight: "100px", // Change the marginRight as needed
      marginBottom: "0", // Change the marginBottom as needed
      marginLeft: "0px", // Change the marginLeft as needed
      paddingTop: "0", // Change the paddingTop as needed
      paddingRight: "0", // Change the paddingRight as needed
      paddingBottom: "0", // Change the paddingBottom as needed
      paddingLeft: "0", // Change the paddingLeft as needed
      zIndex: 9999, // Keep the existing zIndex or modify as needed
    }),
  };

  const defaultColDefs = [
    { headerName: "Sr.No", field: "sr", width: "85%" },
    {
      headerName: "CUSTOMER NAME",
      field: "customername",
      width: 250,
    },
    {
      headerName: "INVOICE NUMBER",
      field: "code",
      width: "150%",
      cellClass: "font-semibold",
    },
    {
      headerName: "SALES ORDER",
      field: "salesordercode",
      width: "190%",
    },
    {
      headerName: "GROSS VALUE",
      field: "total_amount_total",
      width: 130,
      cellClass: "font-semibold",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
        }).format(params.value);
      },
    },
    {
      headerName: "STATUS",
      field: "taxinvoicestatus",
      width: 130,
      cellRenderer: (params) => (
        // <>
        //   {params.data.taxinvoicestatus === "Submitted" ? (
        //     <span class=" text-green-500 ">{params.value}</span>
        //   ) : (
        //     <span class=" text-red-500  ">{params.value}</span>
        //   )}
        // </>
        <>
          <StatusCapsule
            type={
              params.data.taxinvoicestatus === "Submitted" ? "success" : "error"
            }
          >
            {params.value}
          </StatusCapsule>
        </>
      ),
    },
    {
      headerName: "INVOICE DATE",
      field: "invoice_date",
      width: "130%",
    },
    {
      headerName: "ACTIVE",
      field: "isactive",
      width: "80",
      valueFormatter: (params) => {
        return params.value ? "Yes" : "No";
      },
    },
    {
      headerName: "CREATED DATE",
      field: "createdon",
      valueFormatter: (params) => {
        return params.value.substr(0, 19);
      },
      width: "120%",
    },
    {
      headerName: "Preview",
      field: "id",
      filter: false,
      // pinned: "right",
      cellRenderer: (params) => (
        // params.data.taxinvoicestatus== 'Submit' ? (
        <button
          className="font-small text-blue-600 dark:text-blue-500  mt-2"
          onClick={(e) => {
            GetPreview(params.value, params.data.code);
          }}
          title="Preview"
        >
          {/* <FaEye className="w-4 h-4 " /> */}
          <FaFilePdf className="w-4 h-4 " />
        </button>
      ),
      // ) : null
      width: 50,
    },

    {
      headerName: "ACTION",
      field: "code",
      pinned: "right",
      cellRenderer: (params) => {
        const { showActionColumn } = params.context;
        const getOptions = () => {
          let options = [
            {
              value: "Preview",
              label: "Preview",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: FaFilePdf,
              params: params,
            },
          ];

          if (showActionColumn && params.data.irn === null) {
            options.push({
              value: "Delete",
              label: "Delete",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(239 68 68)", // Set the label color
              icon: RiDeleteBin6Line,
              params: params,
            });
          }

          if (
            showActionColumn &&
            params.data.taxinvoicestatus === "Submitted" &&
            params.data.irn
          ) {
            options.push({
              value: "Cancel",
              label: "Cancel",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(239 68 68)", // Set the label color
              icon: RiCloseLine,
              params: params,
            });
          }

          return options;
        };

        const options = getOptions();

        return (
          <div style={{ width: "100%", position: "relative", zIndex: 999 }}>
            <Select
              options={options}
              isSearchable={false}
              onChange={handleNavigation}
              placeholder={params.value || "ACTION"}
              menuPlacement="bottom"
              // menuPortalTarget={document.body} // Render the menu in the body
              menuPortalTarget={gridRef.current} // Render the menu in the body
              styles={updatedActionButtonCustomStyle}
              value={null} // Ensure no value is selected
              components={{ Option: CustomOption }} // Use the custom option component
            />
          </div>
        );
      },
      width: 160,
    },
  ];

  const customColDefs = [
    ...defaultColDefs,
    {
      headerName: "Delete",
      field: "id",
      filter: false,
      // pinned: "right",
      cellRenderer: (params) =>
        params.data.irn === null ? (
          <button
            className="font-small text-blue-600 dark:text-blue-500"
            onClick={(e) => {
              deleteTaxInvoice(params.data);
            }}
            title="Delete"
          >
            <RiDeleteBin6Line className="text-base text-red-500" />
          </button>
        ) : null,

      width: 50,
    },

    {
      headerName: "Cancel",
      field: "id",
      filter: false,
      // pinned: "right",
      cellRenderer: (params) => (
        <>
          {/* {params.data.taxinvoicestatus === 'Draft' ? null : ( */}
          {params.data.taxinvoicestatus === "Submitted" && params.data.irn ? (
            <button
              onClick={() => {
                Swal.fire({
                  title: "Are you sure?",
                  html: `You want to cancel this Invoice  <br><span style="color: #FF5733;">${params.data.code}</span><br><br>
                         <input type="text" id="invoiceCodeInput" class="swal2-input" placeholder="Enter invoice code">`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes",
                  preConfirm: () => {
                    const enteredCode =
                      document.getElementById("invoiceCodeInput").value;
                    if (!enteredCode) {
                      Swal.showValidationMessage(
                        `Please enter the invoice code`
                      );
                      return false; // Prevent the modal from closing
                    } else if (enteredCode !== params.data.code) {
                      Swal.showValidationMessage(
                        `Invoice code does not match!`
                      );
                      return false; // Prevent the modal from closing
                    }
                    return { enteredCode: enteredCode };
                  },
                })
                  .then((result) => {
                    if (result.isConfirmed) {
                      params.data.services === "HSN" ||
                      params.data.services === "MIX_HSN_SAC"
                        ? params.data.is_delivery_challan
                          ? navigate(
                              `/taxinvoice/cancel/services/${params.value}`,
                              {
                                state: {
                                  invoice_code: params.data.code,
                                  invoice_date: params.data.invoice_date,
                                  customer_name: params.data.customername,
                                  is_delivery_challan:
                                    params.data.is_delivery_challan,
                                },
                              }
                            )
                          : navigate(`/taxinvoice/cancel/${params.value}`, {
                              state: {
                                invoice_code: params.data.code,
                                invoice_date: params.data.invoice_date,
                                customer_name: params.data.customername,
                              },
                            })
                        : navigate(
                            `/taxinvoice/cancel/services/${params.value}`
                          );
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }}
              className="font-small text-red-600 dark:text-blue-500"
            >
              {params.data.services === "HSN" ||
              params.data.services === "MIX_HSN_SAC" ? (
                <button className="text-red-700 hover:text-black-900 border bg-transparent hover:bg-red-500 border-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-small rounded-md text-xs p-1  text-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800">
                  Cancel EwayBill
                </button>
              ) : (
                <button className="text-red-700 hover:text-black-900 border bg-transparent hover:bg-red-500 border-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-small rounded-md text-xs p-1  text-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800">
                  Cancel IRN
                </button>
              )}
            </button>
          ) : null}
        </>
      ),
      width: 110,
    },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(showActionColumn ? customColDefs : defaultColDefs);
  }, [showActionColumn]);

  const ColDefaultVale = { filter: true };

  //CustomeStyle of Ag Grid...
  const customeStyle = { height: 480, width: "100%", fontSize: "12px" };

  return (
    <>
      {erplist.some((item) => item.erp_module_id === 52 && item.view) ? (
        <div className="overflow-hidden">
          <div className="flex p-2 flex-row w-full items-center">
            <Text
              className="text-base md:text-[22px] whitespace-nowrap text-gray-800 sm:text-xl tracking-[0.20px] w-[85px] "
              size="txtInterSemiBold24"
            >
              {" "}
              Tax Invoices Cancellation
            </Text>

            {/* Search Fuctionallity.. */}
            <Text
              className="text-sm md:text-[22px] whitespace-nowrap text-gray-600 sm:text-xl tracking-[0.20px] ml-36 mr-1"
              size="txtInterSemiBold24"
            >
              {" "}
              Search By :
            </Text>

            <div className="flex gap-2 items-center justify-center">
              <input
                type="radio"
                id="column"
                name="option"
                checked={selectedOption === "column"}
                onChange={(event) => {
                  handleOptionChange(event);
                  setsearchCompanySpecificDateRangeId("");
                  setsearchParameter("");
                  setPage(1);
                }}
                className="scale-100"
              />
              <label className=" text-gray-600  text-sm"> Column</label>

              <input
                type="radio"
                className="scale-100 "
                id="date"
                name="option"
                checked={selectedOption === "date"}
                onChange={(event) => {
                  handleOptionChange(event);
                  setsearchCompanySpecificCriteriaId("");
                  setsearchParameter("");
                  setPage(1);
                }}
              />
              <label className=" text-gray-600 text-sm"> Date</label>

              {selectedOption == "column" && (
                <Select
                  options={searchCompanySpecificCriteria.map((resstate) => ({
                    label: resstate.criteria,
                    value: resstate.id,
                  }))}
                  className="bg-white-A700 border border-gray-200_02"
                  onChange={(selectedoption) => {
                    setsearchCompanySpecificCriteriaId(selectedoption.value);
                    setPage(1);
                  }}
                  defaultValue={
                    searchCompanySpecificCriteria.length > 0
                      ? {
                          label: searchCompanySpecificCriteria[0].criteria,
                          value: searchCompanySpecificCriteria[0].id,
                        }
                      : {
                          label: "Customer", // Set default label when there are no criteria
                          value: null, // Set value to null or a default id if necessary
                        }
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "30px", // Adjust the height as needed
                      // minHeight: '10px', // Ensure the minimum height is also set
                      width: "200px", // Adjust the width as needed
                      display: "flex",
                      alignItems: "center", // Center vertically
                      justifyContent: "center", // Center horizontally
                    }),
                  }}
                />
              )}

              {selectedOption == "date" && (
                <Select
                  options={searchcompanyspecificdaterange.map((resstate) => ({
                    label: resstate.date_range,
                    value: resstate.search_date_range_id,
                  }))}
                  className="bg-white-A700 border border-gray-200_02 "
                  onChange={(selectedoption) => {
                    setsearchCompanySpecificDateRangeId(selectedoption.value);
                    setPage(1);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "30px", // Adjust the height as needed
                      //  minHeight: '10px', // Ensure the minimum height is also set
                      width: "140px", // Adjust the width as needed
                      display: "flex",
                      alignItems: "center", // Center vertically
                      justifyContent: "center", // Center horizontally
                    }),
                  }}
                />
              )}

              {selectedOption == "column" && (
                <input
                  name="searchParamater"
                  type="text"
                  placeholder="Search..."
                  onChange={(e) => {
                    setsearchParameter(e.target.value);
                    setPage(1);
                  }}
                  // onChange={formik.handleChange}
                  className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-40"
                ></input>
              )}

              {selectedOption == "date" &&
                searchCompanySpecificDateRangeId === 7 && (
                  <div className="flex flex-row">
                    <input
                      name="from_date"
                      type="date"
                      onChange={(e) => {
                        setFormDate(e.target.value);
                        setsearchParameter2(
                          e.target.value.concat("@" + toDate)
                        );
                        setPage(1);
                      }}
                      className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[40%]  pt-4"
                    />
                    <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2  ">
                      To
                    </Text>

                    <input
                      name="to_date"
                      type="date"
                      onChange={(e) => {
                        setToDate(e.target.value);

                        setsearchParameter2(
                          formDate.concat("@" + e.target.value)
                        );
                        setPage(1);
                      }}
                      className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px]   pt-4"
                    />
                  </div>
                )}
            </div>
          </div>
          <ToastContainer />
          <div
            id="my-table1"
            className="ag-theme-quartz mb-1"
            ref={gridRef}
            // style={customeStyle}
          >
            <AgGridReact
              rowData={taxinvoice.map((taxinvoice, index) => ({
                ...taxinvoice,
                sr: index + (offsetforSR + 1),
              }))}
              columnDefs={colDefs}
              context={{ showActionColumn }} // Pass `showActionColumn` through context
              // rowHeight={200}
              // pagination={true}
              // paginationPageSize={50}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              overlayLoadingTemplate={loading ? "Loading..." : null}
              overlayNoRowsTemplate={
                loading
                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                  : "No Record Found"
              }
            />
          </div>

          <div>
            <Pagination
              count={count}
              setRecordPerPage={setRecordPerPage}
              recordPerPage={recordPerPage}
              setLoading={setLoading}
              setData={setTaxInvoice}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default TaxInvoiceCancelList;
